// /galleries/ index — client-side filter (search + year + month) and
// progressive reveal. The full collection (~417 cards) is rendered to
// HTML at build time but only the first N are visible until the user
// clicks "Show more" or applies a filter. Filtering bypasses the slice
// and shows everything that matches.

const INITIAL_COUNT_DEFAULT = 60;
const REVEAL_INCREMENT = 60;

const init = () => {
  const grid = document.querySelector("[data-galleries-grid]");
  if (!grid) return;

  const cards = Array.from(grid.querySelectorAll(".gallery-card"));
  if (cards.length === 0) return;

  const search = document.querySelector("[data-galleries-search]");
  const yearSelect = document.querySelector("[data-galleries-year]");
  const monthSelect = document.querySelector("[data-galleries-month]");
  const countEl = document.querySelector("[data-galleries-count]");
  const moreBtn = document.querySelector("[data-galleries-load-more]");
  const moreWrap = document.querySelector("[data-galleries-more]");
  const emptyEl = document.querySelector("[data-galleries-empty]");

  const initialCount =
    Number(grid.dataset.initialCount) || INITIAL_COUNT_DEFAULT;
  let revealed = initialCount;

  const isFiltering = () =>
    Boolean(
      (search && search.value.trim()) ||
        (yearSelect && yearSelect.value) ||
        (monthSelect && monthSelect.value),
    );

  const cardMatchesFilter = (card) => {
    const yr = yearSelect ? yearSelect.value : "";
    const mo = monthSelect ? monthSelect.value : "";
    const q = search ? search.value.trim().toLowerCase() : "";

    if (yr && card.dataset.year !== yr) return false;
    if (mo && card.dataset.month !== mo) return false;
    if (q) {
      const haystack = (card.dataset.search || "").toLowerCase();
      if (!haystack.includes(q)) return false;
    }
    return true;
  };

  const apply = () => {
    const filtering = isFiltering();
    let visible = 0;
    let matchCount = 0;

    for (const card of cards) {
      const matches = cardMatchesFilter(card);
      if (!matches) {
        card.classList.add("is-filtered-out");
        card.classList.remove("is-overflow");
        continue;
      }
      matchCount += 1;
      card.classList.remove("is-filtered-out");

      if (filtering) {
        // When filtering, show everything that matches — no slice cap
        card.classList.remove("is-overflow");
        visible += 1;
      } else if (matchCount > revealed) {
        card.classList.add("is-overflow");
      } else {
        card.classList.remove("is-overflow");
        visible += 1;
      }
    }

    if (countEl) {
      const total = cards.length;
      if (filtering) {
        countEl.textContent =
          matchCount === 1
            ? `Showing 1 gallery`
            : `Showing ${matchCount} galleries`;
      } else if (visible < total) {
        countEl.textContent = `Showing ${visible} of ${total} galleries`;
      } else {
        countEl.textContent = `Showing all ${total} galleries`;
      }
    }

    if (emptyEl) {
      emptyEl.hidden = matchCount > 0;
    }

    if (moreWrap) {
      // Hide the load-more button when filtering OR when everything visible
      const allShown = !filtering && revealed >= cards.length;
      moreWrap.classList.toggle(
        "is-exhausted",
        filtering || allShown || matchCount === 0,
      );
    }
  };

  if (search) {
    let t = null;
    search.addEventListener("input", () => {
      if (t) clearTimeout(t);
      t = setTimeout(apply, 120);
    });
  }
  if (yearSelect) yearSelect.addEventListener("change", apply);
  if (monthSelect) monthSelect.addEventListener("change", apply);
  if (moreBtn) {
    moreBtn.addEventListener("click", () => {
      revealed += REVEAL_INCREMENT;
      apply();
      // Scroll the next slice into view
      const firstNew = grid.querySelector(".gallery-card.is-overflow");
      if (firstNew) {
        firstNew.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  }

  apply();
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
